// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import Link from "next/link";

// components
import ITSImage from "@/components/ITSImage/ITSImage";
import LinkButton from "@/components/Button/LinkButton";

// styles
import styles from '@/components/Search/PBSKidsSearchRow/PBSKidsSearchRow.module.scss'

function PBSKidsSearchRow() {
  return (
    <div className={styles.pbs_kids_search_row} data-sentry-component="PBSKidsSearchRow" data-sentry-source-file="PBSKidsSearchRow.tsx">
      <div className={styles.pbs_kids_search_row__content}>
        <h2>
          <Link
            href="https://pbskids.org/"
            target="_blank"
            rel="noopener noreferrer"
          data-sentry-element="Link" data-sentry-source-file="PBSKidsSearchRow.tsx">
            <ITSImage
              src={'/images/results/PBS_KIDS_logo.svg'}
              alt='PBS KIDS'
              width={80}
              className={styles.pbs_kids_logo}
            data-sentry-element="ITSImage" data-sentry-source-file="PBSKidsSearchRow.tsx" />
          </Link>
        </h2>
        <p className={styles.pbs_kids_search_row__description}>Educational games and videos from Daniel Tiger’s Neighborhood, Wild Kratts, and more.</p>
        <LinkButton
          href="https://pbskids.org/"
          target="_blank"
          style="white"
          className={styles.pbs_kids_search_row__button}
        data-sentry-element="LinkButton" data-sentry-source-file="PBSKidsSearchRow.tsx">
          Go to PBSKIDS.org
        </LinkButton>
      </div>
      <ITSImage 
        src={'https://image.pbs.org/webobjects/pbs-kids-group-of-kids-Xp0QN1B.png'}
        alt='PBS KIDS characters in a group'
        width={1095}
        height={394}
        className={styles.pbs_kids_search_row__image}
      data-sentry-element="ITSImage" data-sentry-source-file="PBSKidsSearchRow.tsx" />
    </div>
  );
}

export default PBSKidsSearchRow
